import styled from 'styled-components';
import { H3 } from 'modules/Typography';
import { breakpoints } from 'modules/breakpoints';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme/themeGet';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Container = styled.header `
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  padding: ${themeGet('spacing.xl')} 0;
  background-color: ${themeGet('colors.background.50')};

  ${(props) => props.$withTabs &&
    `
    padding-bottom: 0;

    ${Content} {
      padding-bottom: ${themeGet('spacing.xl')};

      ${breakpoints.sm} {
        padding-bottom: ${themeGet('spacing.2xl')};
      }
    }
    `}

  ${breakpoints.sm} {
    padding: ${themeGet('spacing.2xl')} 0;

    ${(props) => props.$withTabs &&
    `
      padding-bottom: 0;
      `}
  }
`;
export const HeaderActionsContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${themeGet('spacing.md')};

  ${breakpoints.sm} {
    flex-direction: row;
  }

  &:not(:last-child) {
    margin-bottom: ${themeGet('spacing.md')};
  }
`;
export const Header = styled.div `
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  gap: ${themeGet('spacing.md')};
  min-height: ${pxToRem(40)};
  overflow: hidden;
`;
export const Actions = styled.div `
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${themeGet('spacing.md')};
`;
export const StyledTypography = styled(H3) `
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  ${breakpoints.lg} {
    -webkit-line-clamp: 1;
  }
`;
